import React from 'react'
import {
  View,
} from '@react-pdf/renderer'
import {
  Style
} from '@react-pdf/types'

import NoContent from '../NoContent'
import styles from './styles'
import TableHeaderCell from './TableHeaderCell'
import Row from './TableRow'

export type TCellStyle =
  | Style
  | Array<Style | undefined>
  | undefined

export type TColumn<
  K extends string,
  V,
> = {
  title: React.ReactNode
  render: (value: V, key: K) => React.ReactNode
  style?: TCellStyle
}

export type TProps<
  Cols extends string,
  Row extends Record<Cols, unknown>,
> = {
  columns: {
    [Col in Cols]?: TColumn<Col, Row[Col]>
  }
  rows: Array<Row>
  getRowKey: (row: Row) => string | number
}

/**
 * Table component to be used in react-pdf instances
 * 
 * Warning: Was adapted from previously created components,
 * implementation may not be ideal, and table columns may be easily
 * broken with different styles or contents
 */
const Table = <
  Cols extends string,
  Row extends Record<string, unknown>,
>({
  columns,
  rows,
  getRowKey,
}: TProps<Cols, Row>): JSX.Element => {
  if (!rows.length)
    return <NoContent />

  const columnEntries = Object.entries(columns) as Array<[Cols, TColumn<Cols, unknown>]>

  return (
    <View style={styles.table}>
      <View style={styles.row}>
        {columnEntries.map(([key, column]) => (
          <TableHeaderCell {...{ key, column }} />
        ))}
      </View>
      {rows.map((row, index) => {
        const rowKey = getRowKey(row)
        return (
          <Row
            key={rowKey}
            rowKey={rowKey}
            index={index}
            columns={columns}
            row={row}
          />
        )
      })}
    </View>
  )
}

export default Table
